import { Pipe, PipeTransform } from '@angular/core';
import { TranslationsService } from '../../services';
import { SystemEntity } from '@wdx/shared/swagger-gen';

@Pipe({
    name: 'entityDisplayName',
})
export class EntityDisplayNamePipe implements PipeTransform {
    constructor(private translationsService: TranslationsService) {}

    transform(
        entityType: SystemEntity,
        rowCount?: number,
        plural = false,
    ): string {
        if (!entityType) {
            return '';
        }

        const isPlural =
            rowCount !== undefined ? rowCount === 0 || rowCount > 1 : plural;

        const pluralSuffix = isPlural ? 'PLURAL' : 'SINGULAR';
        const translationKey = `ENTITY_${entityType.toUpperCase()}_${pluralSuffix}`;

        return this.translationsService.translateTokenisedString(
            translationKey,
        );
    }
}
